module.exports = __webpack_public_path__ + "d31739e5860775ced1716b7317f3e35a.png";